import { canonStatus } from '../../Loads/statusMeta';

/**
 * DÓNDE VA UNA CARGA, SEGÚN SU ESTATUS (20-oct-2026).
 *
 * Lo usan las tarjetas del dashboard del cliente: *Recent loads* pone el camión en ese punto del tramo origen →
 * destino, y *Loads by status* cuenta cuántas siguen en camino.
 *
 * 📌 Es una aproximación visual del ciclo, no una medida: el estatus dice en qué etapa va, no cuántos kilómetros lleva.
 * `undefined` = no está en el ciclo (Dry run, o un estatus que no se conoce): no se dibuja avance.
 */
const PROGRESS: Record<string, number> = {
  unassigned: 0.04,
  assigned: 0.1,
  awaiting: 0.2,
  ontransit: 0.55,
  atdestination: 0.9,
  completed: 1,
};

export const progressOf = (statusName?: string): number | undefined => PROGRESS[canonStatus(statusName)];

/** En camino: dentro del ciclo y sin completar. */
export const isInProgress = (statusName?: string): boolean => {
  const p = progressOf(statusName);
  return p !== undefined && p < 1;
};
